import {Pipe, PipeTransform} from '@angular/core'
import {OccupationType, OccupationTypeMap} from '@sparbanken-syd/loan-backend'

@Pipe({
  name: 'occupationType'
})
export class OccupationTypePipe implements PipeTransform {
  transform(value: OccupationType) {
    return OccupationTypeMap.get(value) as string
  }
}
